import { DependencyList, useEffect } from 'react';

export function useAsyncEffect(effect: () => Promise<void | undefined>, deps?: DependencyList): void {
  const doEffect = async () => {
    try {
      await effect();
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
  };
  useEffect(() => {
    void doEffect();
  }, deps);
}
